import type { ChatEventLog, IntentName, ToolName } from './types';

const MAX_LOG_ENTRIES = 500;
const log: ChatEventLog[] = [];

export function logChatEvent(event: ChatEventLog): void {
  log.push(event);
  if (log.length > MAX_LOG_ENTRIES) log.shift();

  if (import.meta.env.DEV) {
    console.debug('[AI Chat]', {
      intent: event.intent,
      confidence: event.confidence.toFixed(2),
      tools: event.toolsCalled,
      fallback: event.fallback,
      durationMs: event.durationMs,
    });
  }
}

export function getFallbackRate(): number {
  if (log.length === 0) return 0;
  const fallbacks = log.filter(e => e.fallback).length;
  return fallbacks / log.length;
}

export function getIntentDistribution(): Record<string, number> {
  const dist: Record<string, number> = {};
  for (const entry of log) {
    dist[entry.intent] = (dist[entry.intent] ?? 0) + 1;
  }
  return dist;
}

export function getEventLog(): readonly ChatEventLog[] {
  return log;
}

export function clearEventLog(): void {
  log.length = 0;
}
